import { render, staticRenderFns } from "./headerIndex.vue?vue&type=template&id=19c681c2&scoped=true&"
import script from "./headerIndex.vue?vue&type=script&lang=js&"
export * from "./headerIndex.vue?vue&type=script&lang=js&"
import style0 from "./headerIndex.vue?vue&type=style&index=0&id=19c681c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c681c2",
  null
  
)

export default component.exports